<template lang="pug">
.content-wrap
  topbar
  .content-top
    .con
      highlight
      rtt
      .cat-tab.nbswi(ref="categories")
        .swiper.glcat-swiper.nbswi-swiper
          .swiper-wrapper
            .swiper-slide
              .cat(@click="redirectPath('/')")
                img(src='/new/img/tab/c-hot.png')
                | hot
            .swiper-slide
              .cat(@click="redirectPath('/slot')")
                img(src='/new/img/tab/c-slot.png')
                | slots
            .swiper-slide
              .cat.aaa
                img(src='/new/img/tab/c-casino.png')
                | live
            .swiper-slide
              .cat(@click="redirectPath('/table')")
                img(src='/new/img/tab/c-poker.png')
                | poker
            .swiper-slide
              .cat(@click="redirectPath('/bingo')")
                img(src='/new/img/tab/c-bingo.png')
                | bingo
            .swiper-slide
              .cat(@click="redirectPath('/hash')")
                img(src='/new/img/tab/c-hash.png')
                | hash
            template(v-if="isLoggedIn")
              .swiper-slide
                router-link.cat(to="/launchWbet" target="_blank")
                  img(src='/new/img/tab/c-sport.png')
                  | sports
            template(v-else)
              .swiper-slide
                a.cat(@click="$helpers.openModal('#logModal')")
                  img(src='/new/img/tab/c-sport.png')
                  | sports
            .swiper-slide
              .cat(@click="redirectPath('/fishing')")
                img(src='/new/img/tab/c-fish.png')
                | fishing
        .swiper-button-prev.glcat-swiper-prev
        .swiper-button-next.glcat-swiper-next
      .searchbar
        .fav.pointer(v-if="isLoggedIn" @click="toggleFav")
          i.fa-heart(:class="{'fa-solid fav-red': showFav, 'fa-regular': !showFav}")
        .fav.pointer(v-if="!isLoggedIn" @click="$helpers.openModal('#logModal')")
          i.fa-regular.fa-heart
        input.form-control(type='text' v-model="searchinput" placeholder='Search')
        .s-icon
          i.fa-solid.fa-magnifying-glass
      .glmenu.nbswi.mt-2
        .swiper.glpro-swiper.nbswi-swiper
          .swiper-wrapper
            .swiper-slide(@click="changeProvider(2)")
              .g-pro.pro(:class="{'aaa c-filtera' : providerSelected === 2,  'c-filter2': providerSelected !== 2}")
                img(src='/new/img/provider/evolution.png')
            .swiper-slide(@click="changeProvider(3)")
              .g-pro.pro(:class="{'aaa' : providerSelected === 3 }")
                img(src='/new/img/provider/jili.png' )
            .swiper-slide(@click="changeProvider(0)")
              .g-pro.pro(:class="{'aaa' : providerSelected === 0 }")
                img(src='/new/img/bprovider/sexy-baccarat.png')
            .swiper-slide(@click="changeProvider(4)")
              .g-pro.pro(:class="{'aaa c-filtera' : providerSelected === 4,  'c-filter2': providerSelected !== 4}")
                img(src='/new/img/bprovider/winfinity.png')
            .swiper-slide(@click="changeProvider(5)")
              .g-pro.pro(:class="{'aaa' : providerSelected === 5 }")
                img(src='/new/img/bprovider/yeebet.png')
            .swiper-slide(@click="changeProvider(6)")
              .g-pro.pro(:class="{'aaa' : providerSelected === 6 }")
                img(src='/new/img/bprovider/tbl.png')
        .swiper-button-prev.glpro-swiper-prev
        .swiper-button-next.glpro-swiper-next
      favList(v-if="showFav" :searchinput="searchinput")
      sexybcrt(v-if="providerSelected === 0 && !showFav" :searchinput="searchinput")
      //- venus(v-if="providerSelected === 1 && !showFav" :searchinput="searchinput")
      evo(v-if="providerSelected === 2 && !showFav" :searchinput="searchinput")
      jili(v-if="providerSelected === 3 && !showFav" :searchinput="searchinput")
      //- pragmatic(v-if="providerSelected === 3 && !showFav" :searchinput="searchinput")
      winfinity(v-if="providerSelected === 4 && !showFav" :searchinput="searchinput")
      yeebet(v-if="providerSelected === 5 && !showFav" :searchinput="searchinput")
      tbl(v-if="providerSelected === 6 && !showFav" :searchinput="searchinput")
      //- social
      footerInfo(:target="'/casino'")
</template>
<script>
import { EventBus } from '@/store/event';
import topbar from '@/views/default/_topBar.vue'
import highlight from '@/component/_highlight.vue'
import rtt from '@/component/_realTimeTrans.vue'
import favList from '@/component/casino/_favList.vue'
import sexybcrt from '@/component/casino/_sexybcrt.vue'
// import venus from '@/component/casino/_venus.vue'
import evo from '@/component/casino/_evo.vue'
import jili from '@/component/casino/_jili.vue'
// import pragmatic from '@/component/casino/launchone/_pragmatic.vue'
import winfinity from '@/component/casino/launchone/_winfinity.vue'
import yeebet from '@/component/casino/launchone/_yeebet.vue'
import tbl from '@/component/casino/_tbl.vue'
import footerInfo from '@/views/default/_footerArticle.vue'
import social from '@/component/_social.vue'
export default {
  components:{
    topbar,
    highlight,
    rtt,
    footerInfo,
    social,
    favList,
    sexybcrt,
    // venus,
    evo,
    jili,
    // pragmatic,
    winfinity,
    yeebet,
    tbl
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      loading:false,
      showMobile: false,
      providerSelected: 2,
      showSearch: false,
      searchinput:"",
      showFav: false
    }
  },
  computed:{
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    matchedLocale(){
      switch(this.getLanguage){
        case "en":
          return "en"
        case "ph":
          return "ph"
        default :
          return "en"
      }
    },
  },
  watch:{
    sessionToken(newState, oldState){
      this.showFav = false
    }
  },
  created(){
    $('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/casino`);
    // this.checkSize()
    // var vm = this
    // $(window).resize(function () {
    //   vm.checkSize()
    // });
  },
  mounted(){
    EventBus.$on("scroll", (data) => {
			if(data == true){
				this.$nextTick(() => {
					// then wait for the browser’s layout/paint
					requestAnimationFrame(() => {
						setTimeout(this.scrolltoDiv, 500)
					})
				})
			}
		});
    if ($('.glcat-swiper').length) {
			const gboxSwiper = new Swiper('.glcat-swiper', {
				slidesPerView: 6.5,
				spaceBetween: 4,
				navigation: {
					nextEl: '.glcat-swiper-next',
					prevEl: '.glcat-swiper-prev'
				},
				watchOverflow: true,
				autoplay:false,
				breakpoints: {
					768: {
						slidesPerView: 6.5
					},
					960: {
						slidesPerView: 8
					}
				}
			})
    }
    if ($('.glpro-swiper').length) {
      const gboxSwiper = new Swiper('.glpro-swiper', {
        slidesPerView: 3.5,
        spaceBetween: 4,
        navigation: {
            nextEl: '.glpro-swiper-next',
            prevEl: '.glpro-swiper-prev'
        },
        watchOverflow: true,
        autoplay:false,
        breakpoints: {
            768: {
                slidesPerView: 6.5
            },
            960: {
                slidesPerView: 6.5
            }
        }
      })
		}
  },
  methods:{
    redirectPath(target){
      this.$router.push(target).catch(error =>{}).finally(() => {
        this.$nextTick(() => {
          EventBus.$emit('scroll', true);
        });
      });
    },
		scrolltoDiv(){
			const el = this.$refs.categories
      if (!el) return
			
      el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: "nearest"  })
		},
    openModal(){
      $("#logModal").modal('show')
    },
    toggleFav(){
      this.showFav = !this.showFav
    },
    toggleSearch(){
      this.showSearch = !this.showSearch
    },
    cancelSearch(){
      this.showSearch = false
      this.searchinput = ""
    },
    changeProvider(option){
      if(option !== this.providerSelected){
        this.providerSelected = option
      }
      this.showFav = false
      // if(option === this.providerSelected){
      // 	return
      // }else{
      // 	this.providerSelected = option
      // }
    },
    checkSize(){
      if ($(window).width() < 681) {
        this.showMobile = true
      }else{
        this.showMobile = false
      }
    },
  }
}
</script>
  